<template>
	<div class="news-detail-container">
		<Hrader :idShwo="7"></Hrader>
		<div style="height: 70px"></div>
		<div class="banner-container">
		<img :src="currentBannerImage" class="banner-image" />
		<div class="banner-overlay" v-if="currentIndex !== 0 && (currentMainTitle || currentSubTitle)">
			<div class="banner-main-title">{{ currentMainTitle }}</div>
			<div class="banner-sub-title">{{ currentSubTitle }}</div>
		</div>
	</div>

		<div class="rectangle" style="margin-top: -10px">
			<div class="rectangle-with">
				<div class="flex-rectange">
					<div>
						<img src="../../assets/recycling_slices/Vector@2x.png" style="width: 12px; height: 13px" />
					</div>
					<div class="current-recy">
						<span v-if="isFromTag">当前位置：卡券新闻|最新新闻|<span class="tag-name">{{ currentTagLabel }}</span></span>
						<span v-else>当前位置 : 卡券新闻 | <span class="category-name">{{ currentCategoryName }}</span></span>
					</div>
				</div>
			</div>
		</div>

		<div class="main-content">
			<div class="sidebar">
				<div 
					v-for="(item, index) in categories" 
					:key="index" 
					class="sidebar-item"
					:class="{ 'sidebar-item-active': currentIndex === index }"
					@click="selectCategory(index)"
				>
					<img :src="currentIndex === index ? item.activeIcon : item.icon" class="sidebar-icon" />
					<span>{{ item.name }}</span>
				</div>
			</div>

			<div class="content-area">
				<div class="content-header">
					<img v-if="currentCategoryIcon" :src="currentCategoryIcon" class="content-icon" />
					<span class="content-title">{{ currentCategoryName }}</span>
				</div>

				<div class="news-list">
					<div 
						v-for="(news, newsIndex) in currentNewsList" 
						:key="newsIndex" 
						class="news-item"
						@click="goToArticle(news)"
					>
						<div class="news-icon">
							<img :src="news.icon" />
						</div>
						<div class="news-content">
							<h3 class="news-title">{{ news.title }}</h3>
							<p class="news-desc">{{ news.desc }}</p>
							<div class="news-footer">
								<span class="view-count">
									<img src="@/assets/news/date.png" class="date-icon" />
									<span class="news-date">{{ news.date }}</span>
								</span>
								
								<span class="view-count">
									<img src="@/assets/news/Vector.png" class="view-icon" />
									<span>{{ news.views }}</span>
								</span>
							</div>
						</div>
						<div class="news-arrow">
							<img src="@/assets/news/arrow2.png" />
						</div>
					</div>
					
					<!-- 空状态 -->
					<div v-if="currentNewsList.length === 0 && !loading" class="empty-state">
						<img src="@/assets/news/null.png" class="empty-icon" />
						<p class="empty-text">暂无内容~</p>
					</div>
				</div>

				<div class="pagination" v-if="currentNewsList.length > 0">
					<button class="page-btn" :disabled="currentPage === 1">
						<img src="@/assets/news/arrowLeft.png" class="page-arrow" />
					</button>
					<div class="page-numbers">
						<span 
							v-for="page in displayPages" 
							:key="page" 
							class="page-num"
							:class="{ 'page-num-active': currentPage === page, 'page-num-dots': page === '...' }"
							@click="page !== '...' && (currentPage = page)"
						>{{ page }}</span>
					</div>
					<button class="page-btn" :disabled="currentPage === totalPages">
						<img src="@/assets/news/arrowRight.png" class="page-arrow" />
					</button>
					<span class="page-jump">
						<span class="jump-text">跳至</span>
						<input type="number" v-model="jumpPage" class="jump-input" min="1" :max="totalPages" @change="jumpToPage" />
						<span class="jump-text">页</span>
					</span>
					<span class="page-info">/ {{ totalPages }} 页</span>
				</div>
			</div>
		</div>

		<div class="tags-section">
			<div class="tags-container">
				<div 
					v-for="(tag, index) in tags" 
					:key="index" 
					class="tag-item"
					:style="{ backgroundColor: tag.bgColor, color: tag.textColor }"
					@click="filterByTag(tag)"
				>
					{{ tag.name }}
				</div>
			</div>
		</div>

		<Tabr></Tabr>
		<Customer></Customer>
	</div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import Hrader from '@/components/header.vue';
import Tabr from '@/components/tabrButton.vue';
import Customer from '@/components/customer.vue';
import { cardNewsTypeList, cardNewsArticlePage, cardNewsTagList } from '@/utils/api.js';
import { ElMessage } from 'element-plus';

const route = useRoute();
const router = useRouter();

const currentIndex = ref(0);
	const currentPage = ref(1);
	const jumpPage = ref(1);
	const loading = ref(false);
	const totalCount = ref(0);
	const currentTagId = ref(null);
	const isFromTag = ref(false);
	const currentTagLabel = ref('');

const categories = ref([
	{ id: 0, name: '最新新闻', icon: require('@/assets/news/list1.png'), activeIcon: require('@/assets/news/sel1.png'), bannerImage: require('@/assets/news/Maskgroup.png'), mainTitle: '', subTitle: '' }
]);

const currentNewsList = ref([]);
const tags = ref([]);

const currentCategoryName = computed(() => {
	return categories.value[currentIndex.value]?.name || '最新新闻';
});

const currentBannerImage = computed(() => {
	return categories.value[currentIndex.value]?.bannerImage || require('@/assets/news/Maskgroup.png');
});

const currentCategoryIcon = computed(() => {
	return categories.value[currentIndex.value]?.icon || '';
});

const currentMainTitle = computed(() => {
	return categories.value[currentIndex.value]?.mainTitle || '';
});

const currentSubTitle = computed(() => {
	return categories.value[currentIndex.value]?.subTitle || '';
});

const totalPages = computed(() => {
	return Math.ceil(totalCount.value / 10);
});

const displayPages = computed(() => {
	const pages = [];
	const total = totalPages.value;
	const current = currentPage.value;
	
	if (total <= 7) {
		for (let i = 1; i <= total; i++) {
			pages.push(i);
		}
	} else {
		if (current <= 3) {
			pages.push(1, 2, 3, 4, '...', total);
		} else if (current >= total - 2) {
			pages.push(1, '...', total - 3, total - 2, total - 1, total);
		} else {
			pages.push(1, '...', current - 1, current, current + 1, '...', total);
		}
	}
	return pages;
});

const jumpToPage = () => {
	let page = parseInt(jumpPage.value);
	if (!isNaN(page) && page >= 1 && page <= totalPages.value) {
		currentPage.value = page;
		fetchNewsArticles();
	}
	jumpPage.value = currentPage.value;
};

const selectCategory = (index) => {
	currentIndex.value = index;
	currentPage.value = 1;
	currentTagId.value = null;
	fetchNewsArticles();
};

const goToArticle = (news) => {
	router.push({
		path: '/articleDetail',
		query: {
			category: currentIndex.value,
			articleId: news.id
		}
	});
};

const filterByTag = (tag) => {
	if (tag && tag.id !== undefined) {
		currentTagId.value = tag.id;
		currentPage.value = 1;
		currentIndex.value = 0;
		fetchNewsArticles();
	}
};

const getIcon = (item) => {
	if (item.navIcon && item.navIcon !== '0') {
		return item.navIcon;
	}
	return item.logo;
};

const fetchNewsTypes = async () => {
	try {
		const res = await cardNewsTypeList();
		if (res.code === 0 && res.data) {
			const typeList = res.data.map(item => ({
				id: item.id,
				name: item.mainTitle,
				icon: getIcon(item),
				activeIcon: getIcon(item),
				bannerImage: item.navLogo || item.logo,
				mainTitle: item.mainTitle || '',
				subTitle: item.subTitle || ''
			}));
			categories.value = [{ id: 0, name: '最新新闻', icon: require('@/assets/news/list1.png'), activeIcon: require('@/assets/news/sel1.png'), bannerImage: require('@/assets/news/Maskgroup.png'), mainTitle: '', subTitle: '' }, ...typeList];
		}
	} catch (error) {
		console.error('获取新闻类型列表失败:', error);
	}
};

const formatDate = (timestamp) => {
	if (!timestamp) return '';
	const date = new Date(timestamp);
	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, '0');
	const day = String(date.getDate()).padStart(2, '0');
	return `${year}年${month}月${day}日`;
};

const stripHtml = (html) => {
	if (!html) return '';
	const temp = document.createElement('div');
	temp.innerHTML = html;
	return temp.textContent || temp.innerText || '';
};

const fetchNewsArticles = async () => {
		loading.value = true;
		try {
			const category = categories.value[currentIndex.value];
			const params = {
				page: currentPage.value,
				size: 10
			};
			if (category && category.id !== 0) {
				params.typeId = category.id;
			}
			if (currentTagId.value !== null) {
				params.tagId = currentTagId.value;
			}
			const res = await cardNewsArticlePage(params);
		if (res.code === 0 && res.data) {
			currentNewsList.value = res.data.list.map(item => ({
				id: item.id,
				title: item.title,
				desc: item.summary ? stripHtml(item.summary) : (item.content ? stripHtml(item.content).substring(0, 200) + '...' : ''),
				date: formatDate(item.publishTime || item.createTime),
				views: item.browseCount || item.viewCount || 0,
				icon: item.coverLogo || item.coverImage || require('@/assets/news/1.png'),
				content: item.content
			}));
			totalCount.value = res.data.total || res.data.list.length;
		} else {
			currentNewsList.value = [];
			totalCount.value = 0;
			ElMessage.error(res.msg || '获取新闻文章失败');
		}
	} catch (error) {
		console.error('获取新闻文章列表失败:', error);
		ElMessage.error('网络异常，请稍后重试');
		currentNewsList.value = [];
		totalCount.value = 0;
	} finally {
		loading.value = false;
	}
};

const fetchNewsTags = async () => {
	try {
		const res = await cardNewsTagList();
		if (res.code === 0 && res.data) {
			tags.value = res.data.map(item => ({
				id: item.id,
				name: item.name,
				bgColor: item.bgColor,
				textColor: item.textColor
			}));
		}
	} catch (error) {
		console.error('获取新闻标签列表失败:', error);
	}
};

onMounted(() => {
	fetchNewsTypes().then(() => {
		const categoryId = route.query.categoryId;
		if (categoryId !== undefined) {
			const id = parseInt(categoryId);
			if (!isNaN(id) && id >= 0) {
				const idx = categories.value.findIndex(c => c.id === id);
				if (idx >= 0) {
					currentIndex.value = idx;
				}
			}
		}
		
		const tagId = route.query.tagId;
		if (tagId !== undefined) {
			const id = parseInt(tagId);
			if (!isNaN(id) && id > 0) {
				currentTagId.value = id;
			}
		}
		
		const tagName = route.query.tagName;
		if (tagName !== undefined && tagName !== '') {
			isFromTag.value = true;
			currentTagLabel.value = tagName;
		}
		
		fetchNewsArticles();
	});
	fetchNewsTags();
});
</script>

<style lang="scss" scoped>
.news-detail-container {
	min-height: 100vh;
	background-color: #f5f5f5;
}

.banner-container {
	position: relative;
	width: 100%;
	height: auto;
}

.banner-image {
	width: 100%;
	height: auto;
	display: block;
}

.banner-overlay {
	position: absolute;
	top: 50%;
	left: 10%;
	right: 30%;
	transform: translateY(-50%);
	text-align: left;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: center;
	max-width: 60%;
}

.banner-main-title {
	font-family: PingFang SC, PingFang SC;
	font-weight: 600;
	font-size: 42px;
	color: #ffffff;
	line-height: 1.2;
	text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
	margin-bottom: 16px;
}

.banner-sub-title {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 24px;
	color: #ffffff;
	line-height: 1.6;
	text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
	display: -webkit-box;
	-webkit-line-clamp: 4;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
	max-height: 154px;
}

.rectangle {
	width: 100%;
	height: 52px;
	background: #ffffff;
	border-radius: 0px;
}

.rectangle-with {
	width: 1280px;
	margin: auto;
	height: 52px;
}

.flex-rectange {
	display: flex;
	align-items: center;
	height: 52px;
	margin-left: 22px;
}

.current-recy {
	margin-left: 7px;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #333333;
}

.category-name {
	color: #FF3333;
}

.tag-name {
	color: #FF3333;
}

.main-content {
	max-width: 1280px;
	margin: 20px auto;
	display: flex;
	gap: 20px;
}

.sidebar {
	width: 160px;
	height: 100%;
	background: #ffffff;
	border-radius: 8px;
	padding: 18px 18px 18px 0;
	flex-shrink: 0;
}


.sidebar-item {
	display: flex;
	align-items: center;
	padding: 12px 0 12px 8px;
	// margin-left: 18px;
	margin-bottom: 5px;
	border-radius: 0 8px 8px 0;
	cursor: pointer;
	transition: all 0.3s;
	color: #666666;
	font-size: 16px;
}

.sidebar-item-active {
	background: linear-gradient( 90deg, #FF3333 57.85%, rgba(255,51,51,0.8) 100%);
	color: #ffffff;
	border-radius: 0 8px 8px 0;
	margin-left: 0;
	// padding-left: 33px;
}

.sidebar-icon {
	width: 16px;
	height: 16px;
	margin-right: 10px;
}

.content-area {
	flex: 1;
	background: #ffffff;
	border-radius: 8px;
	padding: 20px;
	min-height: 600px;
}

.content-header {
	padding-bottom: 12px;
	border-bottom: 1px solid #EEEEEE;
	margin-bottom: 0;
	display: flex;
	align-items: center;
	gap: 10px;
}

.content-icon {
	width: 14px;
	height: 14px;
	object-fit: contain;
}

.content-title {
	font-family: PingFang SC, PingFang SC;
	font-weight: 600;
	font-size: 20px;
	color: #333333;
}

.news-list {
	display: flex;
	flex-direction: column;
}

.news-item {
	display: flex;
	align-items: center;
	padding: 20px 0;
	border-bottom: 1px solid #EEEEEE;
	cursor: pointer;
	transition: all 0.3s;
}

.news-item:last-child {
	border-bottom: none;
}

.news-item:hover {
	background: #FAFAFA;
}

.news-icon {
	width: 144px;
	height: 108px;
	flex-shrink: 0;
	border-radius: 8px;
	overflow: hidden;
	margin-right: 20px;
}

.news-icon img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

.news-content {
	flex: 1;
	min-width: 0;
	display: flex;
	flex-direction: column;
	gap: 10px;
}

.news-title {
	font-family: PingFang SC, PingFang SC;
	font-weight: 600;
	font-size: 18px;
	color: #333333;
	margin: 0;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.news-desc {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #AAAAAA;
	line-height: 1.6;
	margin: 0;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	max-width: 800px;
}

.news-footer {
	display: flex;
	align-items: center;
	gap: 36px;
}

.date-icon {
	width: 14px;
	height: 14px;
	object-fit: contain;
}

.news-date {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #B3B3B3;
	margin: 0;
}

.view-count {
	display: flex;
	align-items: center;
	gap: 5px;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #B3B3B3;
}

.view-icon {
	width: 14px;
	height: 11px;
	object-fit: contain;
}

.news-arrow {
	width: 24px;
	height: 24px;
	flex-shrink: 0;
	margin-left: 20px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.news-arrow img {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}

	.empty-state {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding: 60px 0;
	}

	.empty-icon {
		width: 224px;
		height: 224px;
		object-fit: contain;
	}

	.empty-text {
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 16px;
		color: #999999;
		margin-top: 20px;
	}

	.pagination {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	margin-top: 20px;
	gap: 5px;
}

.page-btn {
	width: 40px;
	height: 40px;
	background: #fff;
	border: 1px solid #DDDDDD;
	border-radius: 3px;
	cursor: pointer;
	transition: all 0.3s;
	display: flex;
	align-items: center;
	justify-content: center;
}

.page-btn:hover:not(:disabled) {
	border-color: #FF3333;
}

.page-btn:disabled {
	opacity: 0.5;
	cursor: not-allowed;
}

.page-arrow {
	width: 14px;
	height: 14px;
	object-fit: contain;
}

.page-numbers {
	display: flex;
	gap: 5px;
}

.page-num {
	width: 40px;
	height: 40px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 3px;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #333333;
	cursor: pointer;
	transition: all 0.3s;
	border: 1px solid #DDDDDD;
}

.page-num:hover {
	border-color: #FF3333;
	color: #FF3333;
}

.page-num-active {
	background: #FF3333;
	color: #fff;
	border-color: #FF3333;
}

.page-num-dots {
	border: none;
	cursor: default;
	color: #999999;
}

.page-num-dots:hover {
	border-color: #DDDDDD;
	color: #999999;
}

.page-jump {
	display: flex;
	align-items: center;
	gap: 5px;
	margin-left: 10px;
}

.jump-text {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #333333;
}

.jump-input {
	width: 42px;
	height: 40px;
	border: 1px solid #DDDDDD;
	border-radius: 3px;
	text-align: center;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #333333;
	outline: none;
}

.jump-input:focus {
	border-color: #FF3333;
}

.page-info {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #333333;
	margin-left: 5px;
}

.tags-section {
	background: #fff;
	padding: 20px;
	margin: 0;
	transform: translateY(28px);
}

.tags-container {
	display: flex;
	flex-wrap: wrap;
	gap: 14px;
	max-width: 1280px;
	margin: 0 auto;
}

.tag-item {
	background: rgba(255, 245, 245, 1);
	color: rgba(236, 57, 57, 1);
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	padding: 8px 20px;
	border-radius: 4px;
	cursor: pointer;
	transition: all 0.3s;
}

.tag-item:hover {
	background: rgba(236, 57, 57, 1);
	color: #fff;
}

@media (max-width: 992px) {
	.main-content {
		flex-direction: column;
	}

	.sidebar {
		width: 100%;
	}

	.sidebar-item {
		display: inline-flex;
		margin-right: 10px;
		margin-bottom: 10px;
	}
}
</style>
